import React from "react";
import _findIndex from "lodash/findindex";
import useOnScreen from "../hooks/useOnScreen";
import useScrollSpy from "../hooks/useScrollSpy";
import SubmitBtn from "./submitButton.jsx";
import { AppBar, Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import NavTabsSkeleton from "./skeletons/NavTabsSkeleton.jsx";
import useDevice from "../hooks/useDevice.js";
import { scrollToElement } from "../utils/Utils.js";

const tabTheme = createTheme({
  components: {
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          color: "#696781",
          fontSize: 16,
          padding: "16px",
          fontFamily: "pf_highway_sans_pro_lightRg",
          textTransform: "unset",
          "&.Mui-selected": {
            color: "#0D0C1C",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          height: "100%",
        },
        indicator: {
          height: "4px !important",
          backgroundColor: "#703EFF !important",
        },
        scrollButtons: {
          color: "#696781",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "white",
        },
        positionFixed: {
          boxShadow: "8px 11px 11px -12px rgba(0,0,0,0.15)",
          "@media (min-width: 768px) and (max-width: 1296px)": {
            padding: "0 40px",
          },
          "@media (max-width: 767px)": {
            padding: "0",
          },
        },
        positionRelative: {
          boxShadow: "none",
          width: "auto",
          maxWidth: "1216px",
          margin: "0 16px 16px 16px",
        },
      },
    },
  },
});

const NavigationTabs = (props) => {
  const { isDesktop } = useDevice();
  const buttonVisible = useMediaQuery("(min-width:700px)");
  let isEventPage = props.context === "Event";
  let info = props.pageInfoProp || {};
  let headerVisible = props.headerVisible;
  let items = [];

  if (isEventPage || document.getElementById("r_descSummary"))
    items.push({
      hash: "r_summaryText",
      label: playdetailsv2_resources.LiteralResource10Text,
    });

  if (
    document.getElementById("r_discoverSection") &&
    (!isDesktop || !document.getElementById("r_descSummary"))
  )
    items.push({
      hash: "r_discoverSection",
      label: artistpage_resources.Discover,
    });

  if (document.getElementById("r_eventMedia"))
    items.push({
      hash: "r_eventMedia",
      label: playdetailsv2_resources.Gallery,
    });

  if (
    isEventPage &&
    !info.showModals &&
    !info.nullAdditionalInfo & !info.hasEventEnded
  )
    items.push({
      hash: "r_infoContainer",
      label: playdetailsv2_resources.UsefulInfo,
    });

  if (isEventPage && !info.hasEventEnded) {
    items.push({
      hash: "r_OrganizerContainerMain",
      label:
        info.producerCount > 1
          ? playdetailsv2_resources.Organizers
          : playdetailsv2_resources.Organizer,
    });
    items.push({
      hash: "workspace",
      label: playdetailsv2_resources.EventDates,
    });
  }

  if (document.getElementById("r_eventsSection"))
    items.push({
      hash: "r_eventsSection",
      label: artistpage_resources.Events,
    });

  let ticketSection = document.getElementById("r_ticketsSection");

  if (ticketSection)
    items.push({
      hash: "r_ticketsSection",
      label: artistpage_resources.Tickets,
    });

  if (document.getElementById("r_artistsSection"))
    items.push({
      hash: "r_artistsSection",
      label: artistpage_resources.Artists,
    });

  let tabs = items.map(({ label }, index) => (
    <Tab
      key={index}
      label={label}
      onClick={() => scrollToElement(headerVisible, items[index].hash)}
    />
  ));

  let workspace = document.getElementById("workspace");

  const workspaceVisible = useOnScreen(workspace);

  const active = useScrollSpy({ items });
  const activeIndex = active ? _findIndex(items, ["hash", active]) : 0;

  if (props.loading) return <NavTabsSkeleton isEventPage={isEventPage} />;

  return (
    <ThemeProvider theme={tabTheme}>
      <AppBar
        id={"appbar"}
        position={headerVisible ? "relative" : "fixed"}
        {...(headerVisible && {
          sx: isEventPage
            ? { borderBottom: "1px solid #EDF1F6" }
            : { margin: "0 16px 0 16px" },
        })}
      >
        <Box
          className="tabsContainer"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            maxWidth: "1216px",
            padding: headerVisible ? "0" : "0 16px",
          }}
        >
          <Tabs
            value={activeIndex > 0 ? activeIndex : 0}
            variant="scrollable"
            {...(headerVisible &&
              !isEventPage && { sx: { borderBottom: "1px solid #EDF1F6" } })}
          >
            {tabs}
          </Tabs>
          {buttonVisible &&
            !workspaceVisible &&
            ((!headerVisible && !info.hasEventEnded) ||
              (!isEventPage && ticketSection)) && (
              <SubmitBtn
                buttonText={props.buttonText}
                isSticky={!headerVisible}
                toDoOnClick={() =>
                  scrollToElement(
                    headerVisible,
                    isEventPage ? "workspace" : "r_ticketsSection"
                  )
                }
                venueSeatsProp={props.venueSeatsProp}
              />
            )}
        </Box>
      </AppBar>
    </ThemeProvider>
  );
};

export default NavigationTabs;
